(function Module() {
	'use strict';

	module.exports = {
		usa: {
			postCode: 'Zip',
			city: 'City'
		},
		aus: {
			postCode: 'Postcode',
			city: 'Suburb'
		},
		international: {
			postCode: 'Postcode',
			city: 'City'
		}
	};
})();
